import { useDispatch } from 'react-redux';
import { useAppSelector } from '~/hooks/useAppSelector';
import { hideJobsInvitePopup, showJobInvitesSelectionPop } from '~/actions';
import { ConfirmPopup } from '~/commonComponents';
import AnimatedCheckCircle from './shared/AnimatedCheckCircle';

export const JobsInviteConfirmationPopup = () => {
  const dispatch = useDispatch();
  const { showConfirmation, jobIds } = useAppSelector((state) => state.multiday.jobsInvitePopup);

  if (!showConfirmation || !jobIds?.length) {
    return null;
  }

  return (
    // @ts-expect-error - missing props
    <ConfirmPopup
      Icon={AnimatedCheckCircle}
      title="Shift Posted Successfully!"
      titleStyle={{ marginTop: 14 }}
      description="Would you like to send invites to professionals?"
      descriptionStyle={{ marginBottom: 32 }}
      leftButtonText="No Thanks"
      leftButtonAction={() => dispatch(hideJobsInvitePopup())}
      rightButtonText="Invite"
      rightButtonAction={() => dispatch(showJobInvitesSelectionPop())}
    />
  );
};
